import { render } from "./ChangeNameModal.vue?vue&type=template&id=55c0cb6c&scoped=true"
import script from "./ChangeNameModal.vue?vue&type=script&lang=js"
export * from "./ChangeNameModal.vue?vue&type=script&lang=js"

import "./ChangeNameModal.vue?vue&type=style&index=0&id=55c0cb6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c0cb6c"]])

export default __exports__